import { FC, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import style from './index.module.css';

export const Button: FC<{ 
  type?: 'primary' | 'secondary' | 'narrow',
  externalLink?: string,
  internalLink?: string,
  onClick?: () => void,
  disabled?: boolean,
  children: ReactNode
}> = ({ 
  type = 'primary',
  externalLink = '',
  internalLink = '',
  onClick = () => {},
  disabled = false,
  children 
}) => {

  const className = style[type];

  return externalLink ? (
    <a href={externalLink} target="_parent" className={className}>
      {children}
    </a>
  ) : internalLink ? (
    <Link to={internalLink} className={className}>
      {children}
    </Link>
  ): (
    <button 
      className={className}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  )
}